/**
 * TabBar 统一配置中心
 * 所有与TabBar相关的配置都在这里定义
 * 实现真正的单一数据源 (Single Source of Truth)
 */

export interface TabBarConfig {
  text: string;
  icon: string;
  activeIcon: string;
  path: string;
  needLogin?: boolean;
}

/**
 * TabBar 配置 - 唯一的数据源
 */
export const TAB_BAR_CONFIG: readonly TabBarConfig[] = [
  {
    text: '首页',
    icon: 'home',
    activeIcon: 'home',
    path: '/pages/tab/home/index',
    needLogin: false,
  },
  {
    text: '列表',
    icon: 'list',
    activeIcon: 'list',
    path: '/pages/tab/list/index',
    needLogin: false,
  },
  {
    text: '我的',
    icon: 'account',
    activeIcon: 'account',
    path: '/pages/tab/user/index',
    needLogin: true,
  },
] as const;

/**
 * 主题配置 - 统一的视觉样式
 */
export const TAB_BAR_THEME = {
  primary: '#21d59d',
  content: '#60687e',
  background: '#ffffff',
  iconSize: 22,
} as const;

/**
 * 导出所有TabBar页面路径 - 供其他模块使用
 */
export const TAB_BAR_PATHS = TAB_BAR_CONFIG.map(tab => tab.path);

/**
 * 工具函数：根据路径获取TabBar配置
 */
export function getTabConfigByPath(path: string): TabBarConfig | undefined {
  return TAB_BAR_CONFIG.find(tab => tab.path === path);
}

/**
 * 工具函数：判断路径是否为TabBar页面
 */
export function isTabBarPath(path: string): boolean {
  return TAB_BAR_PATHS.includes(path);
}
